import { Box, Container, Heading, Image, Stack, Text } from '@chakra-ui/react'

type BuilderQAndAProps = {
  content: {
    question: string
    answer: string
  }[]
}

export const BuilderQAndA = (props: BuilderQAndAProps) => {
  if (props.content.length === 0) return null

  return (
    <div style={{ position: 'relative', overflow: 'hidden', width: '100%' }}>
      <Image
        src='/img/square-chat-bubbles.svg'
        alt=''
        left={{ base: '50%', lg: 'calc(50% - 625px)' }}
        width='300px'
        opacity='0.25'
        pos='absolute'
        top={{ base: 0, lg: 0 }}
      />
      <Container maxW='3xl' pos='relative' pb={8}>
        <Box
          p={2}
          opacity={0.125}
          pos='relative'
          left={{ base: 0, lg: '48px' }}
          pt={{ base: 24, lg: 6 }}
          style={{ rotate: '-4deg', transformOrigin: 'left bottom' }}>
          <Heading fontSize='7xl'>Builder Q&A</Heading>
        </Box>
        <Stack gap={4}>
          {props.content.map(item => (
            <Stack key={item.question}>
              <Text fontWeight='bold' fontSize='xl'>
                {item.question}
              </Text>
              <Text fontWeight='bold'>{item.answer}</Text>
            </Stack>
          ))}
        </Stack>
      </Container>
    </div>
  )
}
